import Nav from "./Nav";

function Header() {
    return (
        <header className="header" id="header">
            <Nav />
        </header>
    );
}

export default Header;
